import { useState, useRef } from 'react';
import TemplatesModalView from './view';

export default function TemplatesModal({ modalRef }) {
    const [open, setOpen] = useState(false);
    const onSelectRef = useRef(null);

    modalRef.current = {
        open(onSelectTemplate) {
            onSelectRef.current = onSelectTemplate ?? null;
            setOpen(true);
        },
        close() {
            setOpen(false);
        },
    };

    function handleClose() {
        setOpen(false);
    }

    function handleSelectTemplate(formData) {
        setOpen(false);
        onSelectRef.current?.(formData);
    }

    return (
        <TemplatesModalView
            open={open}
            onClose={handleClose}
            onSelectTemplate={handleSelectTemplate}
        />
    );
}
